import * as React from "react";
function SvgFunnelMinus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinejoin="round"
        d="M1 3h30L19 17v12h-6V17L1 3z"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path fill="none" d="M32 21h-8" strokeWidth={2} stroke="currentColor" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFunnelMinus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
